var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.6 511.6",
    style: {
      enableBackground: "new 0 0 511.6 511.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M468.977,127.901V74.614c0-11.772-9.555-21.327-21.326-21.327H21.32C9.547,53.287,0,62.842,0,74.614 v53.287H468.977z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#656D78"
    },
    points: "468.977,415.676 395.878,415.676 0,415.676 0,95.926 468.977,95.926 468.977,319.079 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M42.631,74.614c0,5.886-4.771,10.648-10.656,10.648S21.32,80.5,21.32,74.614 S26.09,63.95,31.975,63.95S42.631,68.729,42.631,74.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M74.606,74.614c0,5.886-4.77,10.648-10.655,10.648c-5.887,0-10.656-4.762-10.656-10.648 s4.769-10.663,10.655-10.663S74.606,68.729,74.606,74.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M106.58,74.614c0,5.886-4.77,10.648-10.655,10.648S85.27,80.5,85.27,74.614S90.04,63.95,95.925,63.95 S106.58,68.729,106.58,74.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6E51"
    },
    d: "M373.052,138.565H53.294c-5.886,0-10.663,4.762-10.663,10.647c0,5.886,4.777,10.664,10.663,10.664 h319.758c5.87,0,10.647-4.778,10.647-10.664C383.699,143.326,378.922,138.565,373.052,138.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EB"
    },
    d: "M53.294,202.514h170.531c5.886,0,10.655-4.777,10.655-10.664c0-5.886-4.77-10.663-10.655-10.663 H53.294c-5.886,0-10.663,4.777-10.663,10.663C42.631,197.737,47.408,202.514,53.294,202.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48CFAD"
    },
    d: "M287.776,223.826H53.294c-5.886,0-10.663,4.778-10.663,10.664s4.777,10.648,10.663,10.648h234.481 c5.885,0,10.647-4.762,10.647-10.648S293.66,223.826,287.776,223.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D9CEC"
    },
    d: "M53.294,287.777h149.212c5.886,0,10.663-4.778,10.663-10.664s-4.777-10.648-10.663-10.648H53.294 c-5.886,0-10.663,4.763-10.663,10.648S47.408,287.777,53.294,287.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M223.825,309.087H53.294c-5.886,0-10.663,4.777-10.663,10.664c0,5.886,4.777,10.663,10.663,10.663 h170.531c5.886,0,10.655-4.777,10.655-10.663C234.481,313.863,229.711,309.087,223.825,309.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M138.556,351.725H53.294c-5.886,0-10.663,4.777-10.663,10.664c0,5.886,4.777,10.647,10.663,10.647 h85.262c5.886,0,10.663-4.762,10.663-10.647C149.219,356.503,144.442,351.725,138.556,351.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M511.6,373.036v-63.95h-26.791c-1.125-3.2-2.42-6.338-3.872-9.367l18.923-18.938l-45.215-45.23 l-18.923,18.938c-3.06-1.452-6.183-2.748-9.399-3.888v-26.776h-63.949v26.776c-3.201,1.14-6.34,2.436-9.368,3.888l-18.938-18.938 l-45.23,45.23l18.955,18.938c-1.469,3.029-2.748,6.167-3.889,9.367h-26.775v63.95h26.775c1.141,3.217,2.42,6.339,3.889,9.384 l-18.955,18.938l45.23,45.214l18.938-18.938c3.028,1.467,6.167,2.763,9.368,3.887v26.792h63.949v-26.792 c3.217-1.124,6.34-2.42,9.399-3.887l18.923,18.938l45.23-45.214l-18.938-18.938c1.452-3.045,2.747-6.167,3.872-9.384H511.6z  M394.348,373.036c-17.643,0-31.975-14.316-31.975-31.975s14.332-31.976,31.975-31.976c17.674,0,31.975,14.317,31.975,31.976 S412.022,373.036,394.348,373.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M394.348,287.777c-29.383,0-53.271,23.902-53.271,53.286c0,29.383,23.889,53.302,53.271,53.302 c29.398,0,53.303-23.919,53.303-53.302C447.651,311.678,423.746,287.777,394.348,287.777z M394.348,373.036 c-17.643,0-31.975-14.316-31.975-31.975s14.332-31.976,31.975-31.976c17.674,0,31.975,14.317,31.975,31.976 S412.022,373.036,394.348,373.036z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/service-2.0f89774a12c093c4be05a3fdb156f497.svg";
export { ForwardRef as ReactComponent };